"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INPUT_PADDING_CONDENSED = exports.INPUT_PADDING = exports.INPUT_GAP_BELOW = void 0;
const INPUT_PADDING = exports.INPUT_PADDING = 20;
const INPUT_PADDING_CONDENSED = exports.INPUT_PADDING_CONDENSED = 10;
const INPUT_GAP_BELOW = exports.INPUT_GAP_BELOW = 6;